import React from 'react';
import { Link } from 'react-router-dom';

function CookiePolicy() {
  return (
    <div className="page policy-page">
      <section className="page-hero">
        <div className="container">
          <div className="page-hero-content">
            <span className="page-badge">Legal</span>
            <h1>Cookie Policy</h1>
            <p>Last updated: April 2026</p>
          </div>
        </div>
      </section>

      <section className="page-content">
        <div className="container">
          <div className="policy-content">
            <h2>1. What Are Cookies?</h2>
            <p>
              Cookies are small text files that are stored on your computer or mobile device when you visit a website. 
              They are widely used to make websites work more efficiently, provide information to website owners, and 
              enhance user experience.
            </p>
            <p>
              Cookies can be "persistent" (remaining on your device until deleted or until they expire) or "session" 
              cookies (deleted when you close your browser).
            </p>

            <h2>2. How We Use Cookies</h2>
            <p>SlotsHub UK uses cookies for the following purposes:</p>

            <h3>Essential Cookies</h3>
            <p>
              These cookies are necessary for the website to function and cannot be switched off in our systems. 
              They are usually only set in response to actions made by you which amount to a request for services, 
              such as setting your privacy preferences or filling in forms.
            </p>
            <table className="cookie-table">
              <thead>
                <tr>
                  <th>Cookie Name</th>
                  <th>Purpose</th>
                  <th>Duration</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>ageVerified</td>
                  <td>Remembers if you have confirmed you are over 18</td>
                  <td>1 year</td>
                </tr>
                <tr>
                  <td>cookiesAccepted</td>
                  <td>Stores your cookie consent preferences</td>
                  <td>1 year</td>
                </tr>
              </tbody>
            </table>

            <h3>Analytics Cookies</h3>
            <p>
              These cookies allow us to count visits and traffic sources so we can measure and improve the performance 
              of our site. They help us know which pages are the most and least popular and see how visitors move 
              around the site.
            </p>
            <table className="cookie-table">
              <thead>
                <tr>
                  <th>Cookie Name</th>
                  <th>Purpose</th>
                  <th>Duration</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>_ga</td>
                  <td>Google Analytics - distinguishes users</td>
                  <td>2 years</td>
                </tr>
                <tr>
                  <td>_ga_*</td>
                  <td>Google Analytics - maintains session state</td>
                  <td>2 years</td>
                </tr>
              </tbody>
            </table>

            <h3>Marketing Cookies</h3>
            <p>
              These cookies may be set through our site by our advertising partners. They may be used by those 
              companies to build a profile of your interests and show you relevant adverts on other sites.
            </p>

            <h2>3. Third-Party Cookies</h2>
            <p>
              In addition to our own cookies, we may also use various third-party cookies to report usage statistics 
              of the Service and deliver advertisements on and through the Service.
            </p>
            <p>
              When you click on links to third-party websites (such as casinos), those websites may place their own 
              cookies on your device. We have no control over these third-party cookies. Please refer to the privacy 
              and cookie policies of those websites for more information.
            </p>

            <h2>4. Managing Cookies</h2>
            <p>
              Most web browsers allow you to control cookies through their settings preferences. However, if you 
              limit the ability of websites to set cookies, you may worsen your overall user experience, since it 
              will no longer be personalised to you.
            </p>

            <h3>How to Control Cookies in Your Browser</h3>
            <p>You can control and/or delete cookies as you wish. Here's how in common browsers:</p>
            <ul>
              <li><strong>Chrome:</strong> Settings → Privacy and Security → Cookies and other site data</li>
              <li><strong>Firefox:</strong> Options → Privacy & Security → Cookies and Site Data</li>
              <li><strong>Safari:</strong> Preferences → Privacy → Cookies and website data</li>
              <li><strong>Edge:</strong> Settings → Cookies and site permissions → Cookies and site data</li>
            </ul>

            <h3>Opting Out of Analytics</h3>
            <p>
              You can opt out of Google Analytics by installing the Google Analytics Opt-out Browser Add-on: 
              <a href="https://tools.google.com/dlpage/gaoptout" target="_blank" rel="noopener noreferrer">
                https://tools.google.com/dlpage/gaoptout
              </a>
            </p>

            <h2>5. Do Not Track Signals</h2>
            <p>
              Some browsers incorporate a Do Not Track (DNT) feature that signals to websites you visit that you 
              do not want to have your online activity tracked. Given that there is not a uniform way that browsers 
              communicate the DNT signal, our Site does not currently respond to browser DNT signals.
            </p>

            <h2>6. Updates to This Policy</h2>
            <p>
              We may update this Cookie Policy from time to time to reflect changes in technology, legislation, 
              our business operations, or any other reason we determine is necessary or appropriate. Any changes 
              will become effective when we post the revised policy on our Site.
            </p>

            <h2>7. Contact Us</h2>
            <p>
              If you have any questions about our use of cookies or this Cookie Policy, please contact us at:
            </p>
            <p>
              <strong>Email:</strong> privacy@slotshubuk.com<br />
              <strong>Website:</strong> <Link to="/contact">slotshubuk.com/contact</Link>
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default CookiePolicy;
